const subheader = [{"key":"subheader.contribute_button","string":"Dodaj"},{"key":"subheader.home","string":"Začni"},{"key":"subheader.start","string":"Platforma za strokovnjake"},{"key":"subheader.contribute","string":"Dodaj"},{"key":"subheader.confirm_account","string":"Potrdi račun"},{"key":"subheader.reset_password","string":"Ponastavi geslo"},{"key":"subheader.knowledge_repository","string":"Repozitorij"},{"key":"subheader.yellow_pages","string":"Rumene strani"},{"key":null,"string":null}]

export default subheader



// WEBPACK FOOTER //
// ./src/i18n/sl/subheader/_subheader.js